import request from "@/utils/request"

/****************
 *    Sliders
 ****************/
export function getSliders() {
  return request({
    url: "/api/sliders",
    method: "get"
  })
}

/**
 *
 * @param {Number} id - support id to delete
 */
export function getSlider(id) {
  return request({
    url: "/api/sliders/" + id,
    method: "get"
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function createSlider(data, params = {}) {
  return request({
    url: "/api/sliders",
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Object} params - request params
 * @param {Object} data - request data
 */
export function updateSlider(id, data, params = {}) {
  return request({
    url: "/api/sliders/" + id,
    method: "post",
    params,
    data
  })
}

/**
 *
 * @param {Number} id - support id to delete
 */
export function deleteSlider(id) {
  return request({
    url: "/api/sliders/" + id,
    method: "delete"
  })
}
